import {
  FETCH_CODE8OCCURRENCES_REQUEST,
  FETCH_CODE8OCCURRENCES_SUCCESS,
  FETCH_CODE8OCCURRENCES_ERROR,
  FETCH_CODE8OCCURRENCES_REQUEST_V2,
  FETCH_CODE8OCCURRENCES_SUCCESS_V2,
  FETCH_CODE8OCCURRENCES_ERROR_V2,
} from 'actionTypes'

const DEFAULT_STATE = {
  record: {},
  error: null,
  isFetching: false,
  filters: {},
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_CODE8OCCURRENCES_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      }

    case FETCH_CODE8OCCURRENCES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        record: action.payload,
        filters: action.filters,
      }

    case FETCH_CODE8OCCURRENCES_ERROR:
      return {
        ...state,
        isFetching: false,
        record: {},
        error: action.payload,
        filters: action.filters,
      }

      case FETCH_CODE8OCCURRENCES_REQUEST_V2:
      return {
        ...state,
        isFetching: true,
        error: null,
      }

    case FETCH_CODE8OCCURRENCES_SUCCESS_V2:
      return {
        ...state,
        isFetching: false,
        error: null,
        record:  action.payload,
        filters: action.filters,
      }

    case FETCH_CODE8OCCURRENCES_ERROR_V2:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
        record: {},
        filters: action.filters,
      }

    default:
      return state
  }
}

export default record
